import { FC } from 'react'
import { List } from '@emotion-icons/fluentui-system-regular/List'
import { InsightContainer } from 'src/v2/views/owner-reveal/insights/container'
import { BuyVsSellOvertime } from 'src/v2/views/owner-reveal/insights/portfolio-summary/buy-vs-sell-overtime'
import { PropertyTypeBreakdown } from 'src/v2/views/owner-reveal/insights/portfolio-summary/property-type-breakdown'
import { COMMANDAI_IDS_MAP } from 'src/constants/command-ai-ids'
import { Insight } from 'src/components/insights/types'
import { InsightComponentProps } from 'src/components/insights/types'
import { isFeatureEnabled } from 'src/utils/feature-flag'
import { Colors } from 'src/components/theme'

const PortfolioSummaryContent: FC<InsightComponentProps> = ({ insight }) => {
  const showOwnerRevealMockData = isFeatureEnabled('owner-reveal-mock-data')

  return (
    <InsightContainer insight={insight} color={Colors.primaryRed700} iconBgColor={Colors.primaryRed50}>
      {showOwnerRevealMockData && <BuyVsSellOvertime />}
      <PropertyTypeBreakdown />
    </InsightContainer>
  )
}

export const PortfolioSummary: Insight = {
  id: 'portfolio-summary',
  tabId: COMMANDAI_IDS_MAP.ownerReveal['entity-porfolio-summary-insights-tab'],
  component: PortfolioSummaryContent,
  name: 'Portfolio Summary',
  icon: List,
  linkTooltipFile: 'portfolio-summary',
  supportedResultTypes: ['owner'],
}
